import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Navigate to My Team Tasks with optional drill-down filters in location.state.
 * Preserves the encrypted team route id.
 */
export const useTeamOverviewDrilldown = (encryptedTeamId) => {
  const navigate = useNavigate();

  const openTaskList = (filters = {}) => {
    if (!encryptedTeamId) return;
    navigate(`/myteams/teamtasks/${encryptedTeamId}`, {
      state: {
        fromTeamOverview: true,
        overviewFilters: {
          planningId: filters.planningId ?? null,
          projectId: filters.projectId ?? null,
          userId: filters.userId ?? null,
          taskStatusId: filters.taskStatusId ?? null,
          taskCategoryId: filters.taskCategoryId ?? null,
          fromDate: filters.fromDate ?? null,
          toDate: filters.toDate ?? null,
          isOverdue: Boolean(filters.isOverdue),
        },
      },
    });
  };

  return { openTaskList };
};

export default useTeamOverviewDrilldown;
